import * as React from 'react';
/**
 *
 * Original name: pin
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=400%3A1242
 *
 */
export const PinFill = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "m18.841 8.041-2.879-2.88a2.254 2.254 0 0 0-3.18 0L11.19 6.749l1 1-1.94 1.94-.91-.91a2.25 2.25 0 0 0-3.182 0l-1.969 1.968 4 4-3.22 3.22 1.061 1.06 3.22-3.219 4 4 1.97-1.969a2.25 2.25 0 0 0 0-3.182l-.908-.906 1.938-1.941 1 1 1.591-1.585a2.25 2.25 0 0 0 0-3.182v-.001Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
